module Meevo.Plugins.Integrations {
    "use strict";
    import IIntegration = Meevo.Model.IIntegration;
    enum TestConnectionEnum {
        Failed = 0,
        Success = 1
    }

    /**
     * Main Section of Integrations
     */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.IIntegration> {
        public tempDisplayName: string;
        public connectionStatus: TestConnectionEnum = null;
        public lockedEnableCheckbox: boolean = false;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings: Components.Common.IAppSettings,
            protected busyService: Meevo.Components.Busy.IBusyService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey)
        }

        createSectionModelInstance(postAdd:(data:any)=>any): void {
            this.dataService.getTemplate(this.appSettings.API_ENDPOINTS.integration).then((data: IIntegration) => {
                this.model = data;

                this.lockedEnableCheckbox = true;
                this.parseSettings();
            });
        }

        /**
         * Parse settings list or one setting
         * @param {number} [index] - index
         * */
        public parseSettings(index?: number): void {
            if (this.model && typeof index === 'undefined') {
                this.model.integrationSettings.forEach((setting: Meevo.Model.IIntegrationSetting) => {
                    setting.enabled = _.some([setting.isInsert, setting.isUpdate, setting.isDelete]);
                });
            } else {
                let setting: Meevo.Model.IIntegrationSetting = this.model ? this.model.integrationSettings[index] : {} as Meevo.Model.IIntegrationSetting;

                setting.enabled = _.some([setting.isInsert, setting.isUpdate, setting.isDelete]);
            }
        }

        /**
         * Check permission to enable isEnabled checkbox
         * */
        public checkEnablingPermission(): void {
            this.lockedEnableCheckbox = this.model.isEnable === false && this.connectionStatus !== TestConnectionEnum.Success;

            if (this.model.isEnable) {
                this.model.statusText = ''; // remove 'disabled' error label
            }
        }

        /**
         * Toggle setting
         * @param {number} [index] - index
         * */
        public toggleSetting(index: number): void {
            let setting: Meevo.Model.IIntegrationSetting = this.model ? this.model.integrationSettings[index] : {} as Meevo.Model.IIntegrationSetting;

            setting.isInsert = setting.enabled;
            setting.isUpdate = setting.enabled;
            setting.isDelete = setting.enabled;
        }

        /**
         * Remove recipient from list
         * @param {number} index
         * */
        public removeRecipient(index: number): void {
            this.model.emailAddresses.splice(index, 1);
        }

        /**
         * Add recipient to list
         * */
        public addRecipient(): void {
            this.model.emailAddresses.push('');
        }

        /**
         * Prepare model to save
         * @returns {Meevo.Model.IIntegration} model
         * */
        public preSave (): Meevo.Model.IIntegration {
            let uniqueRecipients = {};

            this.model.emailAddresses.forEach((mail: string) => {
                if (mail !== '' && !uniqueRecipients[mail]) {
                    uniqueRecipients[mail] = true;
                }
            });

            this.model.emailAddresses = Object.keys(uniqueRecipients);

            return this.model;
        }

        /**
         * Handles retrieval of the item from the data service (if it hasn't already been loaded)
         * @returns {}
         */
        public sectionModelRetrieved(): void {
            this.tempDisplayName = this.model && this.model.displayName ? this.model.displayName : '';
            this.parseSettings();
            if (this.model && this.model.isEnable === false) {
                this.lockedEnableCheckbox = true;
            }
        }

        /**
         * Test URL connection
         * */
        public testConnection(): void {
            let url = `${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.integration}/TestConnection`;

            if (!this.model.urlAddress) {
                return;
            }

            this.connectionStatus = null;
            this.busyService.start();

            this.dataService.customMethodData(url, 'POST', {
                receivingUrl: this.model.urlAddress
            })
                .then(response => {
                    this.busyService.stop();
                    this.connectionStatus = response.data;
                })
                .catch(() => {
                    this.connectionStatus = TestConnectionEnum.Failed;
                })
                .finally(() => {
                    if (this.connectionStatus === TestConnectionEnum.Failed) {
                        this.model.isEnable = false;
                        this.lockedEnableCheckbox = true;
                    } else {
                        this.lockedEnableCheckbox = false;
                    }
                });
        }

        /**
         * Get connection status converted to string
         * */
        get connectionStatusString(): string {
            switch (this.connectionStatus) {
                case TestConnectionEnum.Failed:
                    return 'Failed!';
                case TestConnectionEnum.Success:
                    return 'Success!';
                default:
                    return '';
            }
        }
    }

}